import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

interface MoveBlockActionsProps {
    isDisabled: boolean
    onClick: () => void
    label: string
    shortcut: string
    Icon: React.ElementType
    classes: {
        itemRow: string
        disabled: string
        iconLabelGroup: string
        label: string
        shortcut: string
    }
}

const MoveBlockActions = ({
    isDisabled,
    onClick,
    label,
    shortcut,
    Icon,
    classes,
}: MoveBlockActionsProps) => {
    return (
        <div
            className={clsx(classes.itemRow, {
                [classes.disabled]: isDisabled,
            })}
            onClick={!isDisabled ? onClick : undefined}
            onKeyDown={!isDisabled ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick() } } : undefined}
            role="button"
            tabIndex={isDisabled ? -1 : 0}
            aria-disabled={isDisabled}
            data-testid="move-block-popover"
            data-move-item
        >
            <div className={classes.iconLabelGroup}>
                <Icon fontSize="small" />
                <Typography className={classes.label}>{label}</Typography>
            </div>
            <Typography className={classes.shortcut}>{shortcut}</Typography>
        </div>
    )
}

export default MoveBlockActions
